import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import MultilineTextEditor from '../../../components/common/editors/MultilineTextEditor';
import MultipleItemsEditor from '../../../components/lego/MultipleItemsEditor';
import { SwitchInput } from '../../../components/common/SwitchInput';
import SingleTextEditor from '../../../components/common/editors/SingleTextEditor';
import AIModelSelector from './AIModelSelector';

// Hacky "current tab memory" for the modal
let lastUsedModels = null;
let lastUsedPrompt = null;

export default function LLMPromptModal({ onSubmit, onCancel }) {
  const [llmPrompt, setLlmPrompt] = useState(lastUsedPrompt || 'Determine if the vehicle is combustion engine "ICE", hybrid "HV", plug-in hybrid "PHEV", or full electric "EV"');
  const [llmModels, setLlmModels] = useState(lastUsedModels || [
    { model: 'gemini-flash-latest' },
    { model: 'gpt-6.1-sol' }
  ]);
  const [promptTogether, setPromptTogether] = useState(true);

  useEffect(() => {
    lastUsedModels = llmModels;
    lastUsedPrompt = llmPrompt;
  }, [llmModels, llmPrompt]);

  return <div className="p-3">
    <div className="mb-3">
      <label className="form-label">Prompt</label>
      <MultilineTextEditor 
        value={llmPrompt}
        onChange={setLlmPrompt}
        minRows={3}
        maxRows={10}
      />
    </div>

    <div className="mb-3">
      <label className="form-label">Models</label>
      <MultipleItemsEditor
        value={llmModels}
        onChange={setLlmModels}
        defaultNewItem={{ model: '' }}
        renderComponent={(model, props) => (
          <AIModelSelector
            {...props}
            value={model.model}
            onChange={(value) => props.onChange({ ...model, model: value })}
          />
        )}
        compact={false}
        buttonsAlwaysVisible={true}
      />
    </div>

    <div className="mb-3">
      <SwitchInput
        label="Prompt models together"
        value={promptTogether}
        onChange={setPromptTogether}
      />
    </div>

    <div className="d-flex justify-content-end">
      <button 
        className="btn btn-secondary mr-2"
        onClick={onCancel}
      >
        Cancel
      </button>
      <button 
        className="btn btn-primary"
        onClick={() => onSubmit({
          prompt: llmPrompt,
          models: llmModels,
          promptTogether
        })}
      >
        Submit
      </button>
    </div>
  </div>;
} 